export type ParkingBranch = 'myeongdong' | 'worldMall' | 'busan' | 'jeju';

export type ParkingBranchItem = { type: 'row'; labelKey: string; valueKey: string } | { type: 'text'; textKey: string };

export interface ParkingBranchSection {
    titleKey: string;
    items: ParkingBranchItem[];
}

export const STORE_CODE_TO_PARKING_BRANCH: Record<string, ParkingBranch> = {
    '0001': 'myeongdong',
    '0002': 'worldMall',
    '0005': 'busan',
};

export function resolveParkingBranch(storeCode?: string | null): ParkingBranch {
    return STORE_CODE_TO_PARKING_BRANCH[storeCode ?? ''] ?? 'jeju';
}

const COMMON_DISCOUNT_ITEMS: ParkingBranchItem[] = [
    { type: 'row', labelKey: 'parking.branch.discount.usd1to99', valueKey: 'parking.branch.discount.oneHourFree' },
    { type: 'row', labelKey: 'parking.branch.discount.usd100to149', valueKey: 'parking.branch.discount.twoHourFree' },
    { type: 'row', labelKey: 'parking.branch.discount.usd150AndAbove', valueKey: 'parking.branch.discount.threeHourFree' },
];

export const PARKING_BRANCH_CONFIG: Record<ParkingBranch, ParkingBranchSection[]> = {
    myeongdong: [
        {
            titleKey: 'parking.branch.title.feeStandard',
            items: [
                { type: 'row', labelKey: 'parking.branch.myeongdong.feeRates.upTo30MinAfterEntry', valueKey: 'parking.branch.myeongdong.feeRates.krw3000' },
                { type: 'row', labelKey: 'parking.branch.myeongdong.feeRates.additional10Min', valueKey: 'parking.branch.myeongdong.feeRates.krw1000' },
            ],
        },
        {
            titleKey: 'parking.branch.title.purchaseAmountDiscount',
            items: COMMON_DISCOUNT_ITEMS,
        },
    ],
    worldMall: [
        {
            titleKey: 'parking.branch.title.feeStandard',
            items: [
                { type: 'row', labelKey: 'parking.branch.worldMall.feeRates.peakHours', valueKey: 'parking.branch.worldMall.feeRates.krw500Per10Min' },
                { type: 'row', labelKey: 'parking.branch.worldMall.feeRates.otherHours', valueKey: 'parking.branch.worldMall.feeRates.krw200Per10Min' },
            ],
        },
    ],
    busan: [
        {
            titleKey: 'parking.branch.title.feeStandard',
            items: [
                { type: 'row', labelKey: 'parking.branch.busan.feeRates.upTo30Min', valueKey: 'parking.branch.busan.feeRates.krw2000' },
                { type: 'row', labelKey: 'parking.branch.busan.feeRates.additional10Min', valueKey: 'parking.branch.busan.feeRates.krw500' },
            ],
        },
        {
            titleKey: 'parking.branch.title.purchaseAmountDiscount',
            items: COMMON_DISCOUNT_ITEMS,
        },
    ],
    jeju: [
        {
            titleKey: 'parking.branch.title.freeParkingTicketDestination',
            items: [{ type: 'text', textKey: 'parking.branch.jeju.destination' }],
        },
    ],
};
